import { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AnimatedTitle from "../../../components/AnimatedTitle/AnimatedTitle";

const blocks = [
  {
    title: "150+",
    description: ["унікальних", "запитів"],
  },
  {
    title: "7",
    description: ["років у сфері", "ІТ-права"],
  },
  {
    title: "20+",
    description: ["зареєстрованих", "торгових марок"],
  },
];


const containerStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  mt: "88px",
  "@media (min-width:1200px)": {
    mt: "208px",
  },
};

const innerContainerStyles = {
  width: "100%",
  maxWidth: "1280px",
};

const gridStyles = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    lg: "1fr 1fr 1fr",
  },
  justifyItems: "center",
  gap: "40px",
  mt: "40px",
};

const titleStyles = {
  fontWeight: 700,
  fontSize: "128px",
  textAlign: "center",
  color: "rgba(11, 25, 62, 0.15)",
  "@media (min-width: 768px)": {
    fontSize: "176px",
  },
};

const descriptionStyles = {
  fontSize: "24px",
  fontWeight: 500,
  textAlign: "center",
  textTransform: "uppercase",
  "@media (min-width: 768px)": {
    fontSize: "26px",
  },
};

const StatBlock = ({ item }) => (
  <Box>
    <Typography sx={titleStyles}>
      {item.title}
    </Typography>
    {item.description.map((line, lineIndex) => (
      <Typography
        key={lineIndex}
        sx={descriptionStyles}
      >
        {line}
      </Typography>
    ))}
  </Box>
);



export default function WhyUsBlock({ scrollToRef }) {

  const paddingStyles = useMemo(() => {
    const windowWidth = window.innerWidth;
    return {
      padding: windowWidth < 960 ? "0 20px" : "0 80px",
    };
  }, []);

  return (
    <Box
      ref={scrollToRef}
      sx={{
        ...containerStyles,
        ...paddingStyles,
      }}
    >
      <Box sx={innerContainerStyles}>
        <AnimatedTitle text="Чому ми?" />
        <Box sx={gridStyles}>
          {blocks.map((item, index) => (
            <StatBlock key={`stat-${index}`} item={item} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}


